import React, { useState } from "react";
import "./TopNav.css";
import { Image, Dropdown } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { logout } from "actions";
import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';

const TopNav = () => {
  const dispatch = useDispatch();
  const [showDropdown, setShowDropdown] = useState(false);

  const session = useSelector((state) => state.session);

  const handleToggle = (isOpen) => {
    setShowDropdown(isOpen);
  };

  const handleLogout = async (event) => {
    event.preventDefault();
    await dispatch(logout());
  };

  return (
    <div className="topNav">
      <Dropdown show={showDropdown} onToggle={handleToggle}>
        <Dropdown.Toggle as="div" id="dropdown-basic" className="cursor-pointer">
          <div className="d-flex justify-content-center align-items-center ms-2">
            <Image src="/assets/images/user.svg" className="user-icon" />
            <div className="ms-2">
              <h5 className="font-13 font-weight-medium mb-0">{!isEmpty(session.user) ? session.user.name : ''}</h5>
              <p className="font-13 font-weight-medium mb-0">{!isEmpty(session.user) ? session.user.email : ''}</p>
            </div>
            <Image
              src="/assets/images/dropdown-arrow.svg"
              className={`ms-2 transition-rotate ${showDropdown ? "rotate-180" : ""
                }`}
              alt="Dropdown"
            />
          </div>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item onClick={handleLogout}> <Image src="/assets/images/logout-icon.svg" className="me-3" /> Logout</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default TopNav;
